import { Unstable_Grid2 as Grid } from '@mui/material';

import { KeyboardDateTimePicker, Select } from '@occc-app/design-system';
import { DateTimeFormat, DateTimeFormatParse, formatDateTime, parseDate } from '@occc-app/lib/date';

import { DateTimeForFilterTemplate } from './datetime-range-fields.schema';
import { TIME_RANGE_OPTIONS } from './datetime-range-fields.constants';
import { TimeRangeOption } from './datetime-range-fields.types';

export type DatetimeRangeFieldsProps<FormField> = {
  modeFieldName: FormField;
  modeFieldValue?: TimeRangeOption;
  modeFieldLabel: string;
  fromFieldName: FormField;
  toFieldName: FormField;
};

const datetimeFilterFieldProps = {
  format: (value: DateTimeForFilterTemplate) => {
    return value ? parseDate(value, DateTimeFormatParse.DateTimeForFilter) : null;
  },
  parse: (value: Date) => {
    return formatDateTime(value, DateTimeFormat.DateTimeForFilter);
  },
};

// TODO: consider reusing it across different filter forms
export function DatetimeRangeFields<FormField extends string>(
  props: DatetimeRangeFieldsProps<FormField>,
) {
  const { modeFieldName, modeFieldValue, modeFieldLabel, fromFieldName, toFieldName } = props;
  return (
    <>
      <Grid xs={12}>
        <Select
          name={modeFieldName}
          label={modeFieldLabel}
          data={TIME_RANGE_OPTIONS}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>
      <Grid xs={12} sm={6}>
        <KeyboardDateTimePicker
          fieldProps={datetimeFilterFieldProps}
          label='Start Date'
          name={fromFieldName}
          disabled={modeFieldValue !== 'CUSTOM_RANGE'}
        />
      </Grid>
      <Grid xs={12} sm={6}>
        <KeyboardDateTimePicker
          fieldProps={datetimeFilterFieldProps}
          label='End Date'
          name={toFieldName}
          disabled={modeFieldValue !== 'CUSTOM_RANGE'}
        />
      </Grid>
    </>
  );
}
